module.exports = __webpack_public_path__ + "static/media/Right-Arrow-Dark.873e2380.svg";